'use client';

import * as Sentry from '@sentry/nextjs';
import Error from 'next/error';
import { useEffect } from 'react';

export default function GlobalError({
  error,
}: {
  error: Error & { digest?: string };
}) {
  useEffect(() => {
    // 将错误上报给 Sentry
    Sentry.captureException(error);
  }, [error]);

  return (
    <html>
      <body>
        {/* 这里可以自定义你的全局错误 UI */}
        <Error statusCode={undefined as any} />
      </body>
    </html>
  );
}